import { connect } from "react-redux";

import OrderBuilder from "./orderBuilder";
import { getFeatureFlagsData } from '../featureFlags/store/selectors';
import {
  getOrderBuilderStatus,
  getOrderBuilderData,
  getCartStatus,
  getCartData,
  getConfigurationGroupStatus,
  getConfigurationGroupData,
  getConfigurationGroupLeft,
  getConfigurationGroupRight,
  getCustomOptionsGroupStatus,
  getCustomOptionsGroupData,
  getCustomOptionsGroupLeft,
  getCustomOptionsGroupRight,
  getCheckboxSettingsStatus,
  getCheckboxSettingsData,
  getPresetData,
  getPresetStatus,
} from "./store/selectors";
import {
  loadOrderBuilder,
  loadConfigurationGroup,
  loadCustomOptionsGroup,
  loadCheckboxSettings,
  loadPresets,
  addOrderToCart,
} from "./store/action-creators";
import {
  getIsStockOrder,
  getProductsData,
  getItemCommentsData,
  getItemCommentsStatus,
} from "../storeHome/store/selectors";
import { setIsStockOrder } from "../storeHome/store/action-creators";
import { loadItemComments } from "../storeHome/store/action-creators";
import { getProfileData } from '../login/store/selectors';

const mapStateToProps = (state) => ({
  featureFlags: getFeatureFlagsData(state),
  orderBuilderStatus: getOrderBuilderStatus(state),
  orderBuilderData: getOrderBuilderData(state),
  configurationGroupStatus: getConfigurationGroupStatus(state),
  configurationGroupData: getConfigurationGroupData(state),
  configurationGroupLeft: getConfigurationGroupLeft(state),
  configurationGroupRight: getConfigurationGroupRight(state),
  customOptionsGroupStatus: getCustomOptionsGroupStatus(state),
  customOptionsGroupData: getCustomOptionsGroupData(state),
  customOptionsGroupLeft: getCustomOptionsGroupLeft(state),
  customOptionsGroupRight: getCustomOptionsGroupRight(state),
  checkboxSettingsStatus: getCheckboxSettingsStatus(state),
  checkboxSettingsData: getCheckboxSettingsData(state),
  cartStatus: getCartStatus(state),
  cartData: getCartData(state),
  productsData: getProductsData(state),
  isStockOrder: getIsStockOrder(state),
  itemCommentsStatus: getItemCommentsStatus(state),
  itemCommentsData: getItemCommentsData(state),
  profileData: getProfileData(state),
  presetsData: getPresetData(state),
  presetsStatus: getPresetStatus(state),
});

const mapDispatchToProps = {
  loadOrderBuilder,
  loadConfigurationGroup,
  loadCustomOptionsGroup,
  loadCheckboxSettings,
  loadItemComments,
  loadPresets,
  addOrderToCart,
  setIsStockOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderBuilder);
